import 'bootstrap';

// Template
import { resetPage, themeInit } from "./theme/resetPage";
import { slideMobileMenu } from "./theme/mobileMenu";
import { sliderConfiguration, videoCarousel } from "./theme/sliders";
import { scrollHeader } from "./theme/scroll";
import { searchCollapse, wishlistCollapse } from "./theme/collapse";
import { accordionWidget } from "./theme/accordion";
import { singleProducts, wooStuff, wishList } from "./theme/woo";

// jQuery wrapper to run on ready state
$(document).ready(() => {
    themeInit();
    resetPage();
    accordionWidget();
    scrollHeader();
    slideMobileMenu();
    searchCollapse();
    //wishlistCollapse();
    sliderConfiguration();
    singleProducts();
    wooStuff();
    videoCarousel();
    //wishList();
});


// jQuery wrapper to run on resize
$(window).on('resize', () => {
    resetPage();
});
